var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { media } from '../../../utilities/media';
const StyledParagraph = styled.p `
  /* Mobile first */
  line-height: 1.31;
  color: ${({ theme, inverted }) => {
    return inverted ? theme.palette.white.main : theme.palette.midnight.main;
}};

  /* Tablet or Desktop  */
  ${media.tablet `
    line-height: 1.5
  `};
`;
export class Paragraph extends React.PureComponent {
    render() {
        const _a = this.props, { children, inverted } = _a, rest = __rest(_a, ["children", "inverted"]);
        // LS WORKAROUND to fix React warning: "Received `false` for a non-boolean attribute `inverted`".
        // more info here: https://github.com/styled-components/styled-components/issues/1198
        // Another interesting option here https://github.com/styled-components/styled-components/issues/439#issuecomment-392395429
        return (React.createElement(StyledParagraph, Object.assign({ inverted: inverted ? inverted : undefined }, rest), children));
    }
}
Paragraph.defaultProps = {
    inverted: false,
};
//# sourceMappingURL=index.js.map